<template>
	<el-container id="kaoshi">
		<div class="titBox">
			<p class="tit">考试安排</p>
			<div class="titRightBox">
				<ul class="qi" :class="$store.state.qiFocus" @click="qiClick">
					<i class="iconfont">&#xe610;</i>
					<li v-for="(index,i) of qiCount" :key="i" @click.stop="qiClick(i)" :class="qiNum==i?'act':''">第{{qiZh(index)}}学期{{qiDang==i?"（当前学期）":""}}</li>
				</ul>
			</div>
		</div>
		<div class="anpaiBox" v-if="kaoshiShow" v-loading="loading">
			<dl class="anpaiList">
				<dd v-for="(item,i) in kaoshiData" :key="i">
					<div class="shiInfo">
						<span>{{i+1}}</span>
						<ul class="kaoMsgBox">
							<li>
								<p class="kaoMsgTit">考试科目：</p>
								<p>{{item.title}}</p>
							</li>
							<li>
								<p class="kaoMsgTit">考试时间：</p>
								<p>{{timeFn(item.start_time, item.end_time)}}</p>
							</li>
							<li>
								<p class="kaoMsgTit">备注：</p>
								<p>{{item.remark}}</p>
							</li>
						</ul>
					</div>
				</dd>
			</dl>
		</div>
		<div class="nodata" v-else>
			<img :src="nodataImg">
			<p>暂无内容</p>
		</div>
	</el-container>
</template>

<script type="text/javscript">
function test_list(that, term){
	let token=that.$cookies.get("token")
	//获取考试列表（有数据版）
	const url = that.global.serverSrc+that.global.qianzui+'/course/'+term+'/test_list';
	that.$ajax.get(url)
	.then(function(res){
		let resData=res.data;
		if(resData.code==0){
			that.kaoshiData=resData.data
			that.loading=false
		}else if(resData.code==1){
			//获取考试列表（无数据版）
			const url = that.global.serverSrc+that.global.qianzui+'/course/'+term+'/test_list';
			that.$ajax.get(url)
			.then(function(res){

			})
			// console.log(resData.code);
			// that.kaoshiShow=false
		}else if(resData.code==401){
			that.$message.error('请求错误，请重新登录');
			that.$selfjs.loginOUtFn(that, "route")
		}else{
			that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
		}
	})
}
export default {
	name: 'kaoshi'
	,data () {
		return {
			qiNum:0
			,qiDang:0
			,qiCount:0
			,kaoshiShow:true
			,loading:true
			,kaoshiData:[]
		}
	}
	,mounted:function(){
		var that = this,
			token=that.$cookies.get("token")

		this.$selfjs.getUserCallFn(this,function(res){
			that.qiDang = res.term-1				//当前学期数
			that.qiNum = res.term-1				//现在选择的学期数
			that.qiCount = res.term_count		//学期数
			
			test_list(that, res.term)
		})
	}
	,methods:{
		//时间文字输出
		timeFn(timeTxt, timeTxt2){
			let resCon="-"
			if(timeTxt != "-"){
				let daytime=timeTxt.split(" ")
					,day=daytime[0]
					,time=daytime[1]
					,dayCon=day.split("-")
				let daytime2=timeTxt2.split(" ")
				resCon=dayCon[0]+"年"+dayCon[1]+"月"+dayCon[2]+"日 "+time+"-"+daytime2[1]
			}
			return resCon;
		},
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//学期选择点击
		qiClick(num){
			var that=this
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				that.qiNum=num
				that.loading=true

				test_list(that, (num+1))
			})
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/renwu/kaoshi.vue